import { createContext } from 'react';
import type { ComponentContextType } from './ComponentProvider';

export const ComponentContext = createContext<ComponentContextType | undefined>(undefined);
